import styled, { css } from 'styled-components'
import { ButtonUnstyled } from '@sketch/components'
import { ReactComponent as PrototypeSvg } from '@sketch/icons/prototype-hotspot-16'
import { ReactComponent as ArtboardSvg } from '@sketch/icons/artboard-16'

/**
 * @TODO Is anything stopping us using SelectorButton here?
 */
export const ArtboardSelectorButton = styled(ButtonUnstyled)`
  min-width: 0px;
  max-width: 100%;
  display: flex;
  align-items: center;
`

const dropdownItemIconCss = css`
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  width: 16px;
  height: 16px;
  flex: none;
  margin-left: 20px;
`

export const StartPointIcon = styled(PrototypeSvg)`
  ${dropdownItemIconCss}
`

export const ArtboardIcon = styled(ArtboardSvg)`
  ${dropdownItemIconCss}
`
